export const smallToLargeKanaMap: { [key: string]: string } = Object.freeze({
  'ァ': 'ア',
  'ィ': 'イ',
  'ゥ': 'ウ',
  'ェ': 'エ',
  'ォ': 'オ',
  'ッ': 'ツ',
  'ャ': 'ヤ',
  'ュ': 'ユ',
  'ョ': 'ヨ',
  'ヵ': 'カ',
  'ヶ': 'ケ',
  'ヮ': 'ワ',
});

export const convertToLargeKana = (inputStr: string): string => {
  return Array.from(inputStr)
    .map(char => smallToLargeKanaMap[char] || char)
    .join('');
};
